// extracted by mini-css-extract-plugin
export default {"mainQRContainer":"QrUserPage_mainQRContainer__5yeUo"};